const UIValidateFormRequired = (message = 'Campo obrigatório') =>
  input => !input ? message : undefined

export default UIValidateFormRequired
